/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiAuthLoginPost } from '../fn/authentication-endpoint/api-auth-login-post';
import { ApiAuthLoginPost$Params } from '../fn/authentication-endpoint/api-auth-login-post';
import { apiAuthLogoutGet } from '../fn/authentication-endpoint/api-auth-logout-get';
import { ApiAuthLogoutGet$Params } from '../fn/authentication-endpoint/api-auth-logout-get';
import { apiAuthRefreshTokenPost } from '../fn/authentication-endpoint/api-auth-refresh-token-post';
import { ApiAuthRefreshTokenPost$Params } from '../fn/authentication-endpoint/api-auth-refresh-token-post';
import { apiAuthResetPasswordPost } from '../fn/authentication-endpoint/api-auth-reset-password-post';
import { ApiAuthResetPasswordPost$Params } from '../fn/authentication-endpoint/api-auth-reset-password-post';

@Injectable({ providedIn: 'root' })
export class AuthenticationEndpointService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiAuthLoginPost()` */
  static readonly ApiAuthLoginPostPath = '/api/auth/login';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAuthLoginPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiAuthLoginPost$Response(params: ApiAuthLoginPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiAuthLoginPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAuthLoginPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiAuthLoginPost(params: ApiAuthLoginPost$Params, context?: HttpContext): Observable<void> {
    return this.apiAuthLoginPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAuthRefreshTokenPost()` */
  static readonly ApiAuthRefreshTokenPostPath = '/api/auth/refreshToken';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAuthRefreshTokenPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiAuthRefreshTokenPost$Response(params: ApiAuthRefreshTokenPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiAuthRefreshTokenPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAuthRefreshTokenPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiAuthRefreshTokenPost(params: ApiAuthRefreshTokenPost$Params, context?: HttpContext): Observable<void> {
    return this.apiAuthRefreshTokenPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAuthResetPasswordPost()` */
  static readonly ApiAuthResetPasswordPostPath = '/api/auth/resetPassword';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAuthResetPasswordPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiAuthResetPasswordPost$Response(params: ApiAuthResetPasswordPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiAuthResetPasswordPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAuthResetPasswordPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiAuthResetPasswordPost(params: ApiAuthResetPasswordPost$Params, context?: HttpContext): Observable<void> {
    return this.apiAuthResetPasswordPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAuthLogoutGet()` */
  static readonly ApiAuthLogoutGetPath = '/api/auth/logout';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAuthLogoutGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAuthLogoutGet$Response(params?: ApiAuthLogoutGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiAuthLogoutGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAuthLogoutGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAuthLogoutGet(params?: ApiAuthLogoutGet$Params, context?: HttpContext): Observable<void> {
    return this.apiAuthLogoutGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
